import React from 'react'
import './working.css'

function INCSUBWorking() {
  return (
    <div className='INCSUBWorking_ctn'>
        <div className='INCSUBWorking_ctn_head'>{'How Does It Work?'}</div>
        <div className='INCSUBWorking_ctn_content'>
            <div className='INCSUBWorking_ctn_content_left'>
                <div className='INCSUBWorking_ctn_content_left_firstmob'>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_text'>
                        <div className='INCSUBWorking_ctn_content_firstmob_head'>{'Member'}</div>
                        <div className='INCSUBWorking_ctn_content_firstmob_text'>{'Start Using Instantly!'}</div>
                    </div>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_img'>
                        <img src='/assets/images/poolsIphone.png'  alt='poolsIphone-img' style={{height: '90%'}} />
                    </div>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_para'>
                        <div className='INCSUBWorking_ctn_content_left_firstmob_para_step'>{'Step 1'}</div>
                        <p>{'Explore a variety of verified subscription pools and pick the one that suits you.'}</p>
                    </div>
                </div>

                <div className='INCSUBWorking_ctn_content_left_firstmob'>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_img'>
                        <img src='/assets/images/checkoutIphone.png'  alt='checkoutIphone-img' style={{height: '90%'}} />
                    </div>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_para'>
                        <div className='INCSUBWorking_ctn_content_left_firstmob_para_step'>{'Step 2'}</div>
                        <p>{'Accept the terms, make the payment, and complete the process in just two clicks.'}</p>
                    </div>
                </div>

            </div>

            <div className='INCSUBWorking_ctn_middleline'></div>
            <div className='INCSUBWorking_ctn_content_right'>
                <div className='INCSUBWorking_ctn_content_left_firstmob'>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_img'>
                        <img src='/assets/images/hostNewPoolIphone.png'  alt='hostNewPoolIphone-img' style={{height: '90%'}} />
                    </div>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_para'>
                        <div className='INCSUBWorking_ctn_content_left_firstmob_para_step'>{'Step 3'}</div>
                        <p>{'Fill out a simple form to create a pool and start sharing.'}</p>
                    </div>
                </div>

                <div className='INCSUBWorking_ctn_content_left_firstmob'>
                    <div className='INCSUBWorking_ctn_content_right_firstmob_text'>
                        <div className='INCSUBWorking_ctn_content_firstmob_head_right'>{'Host'}</div>
                        <div className='INCSUBWorking_ctn_content_firstmob_text_right'>{'Host with ease and maximize your subscription’s value!'}</div>
                    </div>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_img'>
                        <img src='/assets/images/platformIphone.png'  alt='platformIphone-img' style={{height: '90%'}} />
                    </div>
                    <div className='INCSUBWorking_ctn_content_left_firstmob_para'>
                        <div className='INCSUBWorking_ctn_content_left_firstmob_para_step'>{'Step 4'}</div>
                        <p>{'Track verification status, monitor pool members, earnings, and chat—all in MySubscription page.'}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
  )
}

export default INCSUBWorking
